<template>

    <div :class="[!is_enabled ? 'cursor-pointer hover:bg-gray-100' : '', 'group']" @click="clickRow">

        <div class="flex items-center font-bold flex-row justify-between px-4 py-5 sm:p-6">

            <div class="flex flex-grow items-center gap-3">
                <div class="w-12 h-12 rounded-2xl flex items-center justify-center" style="background-color:#000;">
                    <img src="/img/intercom_white.svg" class="h-10 w-10" />
                </div>
                <div class="flex flex-col items-start">
                    <span>Intercom</span>
                </div>
            </div>
            <div class="flex text-white bg items-center" v-if="trigger">
                <div
                    class="inline-flex items-center px-0 py-2 bg-white border border-transparent rounded-md font-semibold text-xs text-birdie-green uppercase tracking-widest ">
                    Connected
                </div>
            </div>
            <transition name="fade">
                <div class="flex text-blue-500 items-center"
                    :class="{ 'opacity-50 pointer-events-none': !$page.props.canManageSettings }"
                    v-if="expandInfo && !is_enabled">
                    <button-link
                        :link="$page.props.canManageSettings ? 'https://www.intercom.com/app-store/?app_package_code=zest-app' : '#'"
                        class="" :title="'Connect ' + app_name + ' with Intercom'">
                        Connect
                    </button-link>
                </div>
            </transition>
        </div>


        <Flows :visible="expandInfo" :fixed="is_enabled" :flows="flows" :docs="docs" :name="name" />

        <div v-if="trigger" class="bg-gray-50 rounded-b-md px-4 py-5 sm:p-8 border-t border-gray-100">

            <!-- <div class="flex items-center gap-2 mb-10">
                <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" />
                <span class="uppercase text-birdie-grey-light text-xs font-space tracking-widest">Screen Recording</span>
            </div> -->

            <!-- <div class="flex flex-row mt-10" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                <span class="text-sm text-gray-600">
                        Please visit <a href="https://www.intercom.com/app-store/?app_package_code=zest-app" :title="'Intercom '+app_name+' app'" target="_blank"
                            class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">
                                Intercom App Store</a> to install {{app_name}}, or take a look at <a href="https://docs.birdie.so/birdie-docs/helpdesk/intercom" target="_blank" title="Intercom integration help"
                                class="text-blue-500 mx-1 hover:text-blue-600 hover:underline">this guide</a> if you need help.
                    </span>
                </div>
            </div> -->



            <div v-if="trigger && !is_modal && the_triggers.length > 1" class="flex flex-row">
                <div class="flex items-center mt-0.5">
                    <span class="font-bold text-gray-600 flex items-center gap-x-2">
                        <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                        Workspace settings for:</span>
                    <jet-dropdown align="left" width="36" class="flex self-center" ref="autobotDropdown">
                        <template #trigger>
                            <span class="inline-flex rounded-md">
                                <button type="button"
                                    class="inline-flex items-center px-2 py-2 border border-transparent leading-4 font-medium rounded-md bg-transparent hover:bg-white  focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition"
                                    :disabled="saving"
                                    :class="!saving ? 'text-blue-500 hover:text-blue-700' : 'text-gray-300 hover:text-gray-500'">
                                    <span class="font-bold">
                                        {{ JSON.parse(trigger.details).user.app.name }}
                                    </span>
                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </span>
                        </template>
                        <template #content>
                            <a href="#" v-for="trig in triggers" :key="'autobot_' + trig.id"
                                class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                :class="{ 'text-blue-500 font-bold': trig.id == trigger.id }"
                                @click.prevent="switchTrigger(trig)">
                                <span class="flex flex-grow">{{ JSON.parse(trig.details).user.app.name }}</span>
                                <vue-feather v-if="trig.id == trigger.id" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </a>
                        </template>
                    </jet-dropdown>
                </div>
            </div>


            <div class="bg-gray-100 p-5 rounded-xl mt-1 ">

                <div class="flex flex-row " v-if="trigger && !is_modal"
                    :class="{ 'pointer-events-none': !$page.props.canManageSettings }">
                    <div class="flex items-center flex-grow">
                        <span class="">Intercom agents can: </span>
                        <jet-dropdown align="left" width="80" class="flex self-center flex-grow"
                            ref="agentscanDropdown">
                            <template #trigger>
                                <span class="inline-flex rounded-md">
                                    <button type="button"
                                        class="inline-flex items-center px-2 py-2 border border-transparent leading-4 font-medium rounded-md bg-transparent hover:bg-white  focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition"
                                        :disabled="saving"
                                        :class="!saving ? 'text-blue-500 hover:text-blue-700' : 'text-gray-300 hover:text-gray-500'">
                                        <span class="font-bold" v-if="agents_can == 'send'">
                                            only send recordings
                                        </span>
                                        <span class="font-bold" v-else-if="agents_can == 'request'">
                                            only request recordings
                                        </span>
                                        <span class="font-bold" v-else>
                                            send and request recordings
                                        </span>
                                        <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </span>
                            </template>
                            <template #content>
                                <a href="#"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                    :class="{ 'text-blue-500 font-bold': agents_can == 'all' }"
                                    @click.prevent="switchAgent('all')">
                                    <span class="flex flex-grow">Send and request recordings</span>
                                    <vue-feather v-if="agents_can == 'all'" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                                <a href="#"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                    :class="{ 'text-blue-500 font-bold': agents_can == 'send' }"
                                    @click.prevent="switchAgent('send')">
                                    <span class="flex flex-grow">Only send recordings</span>
                                    <vue-feather v-if="agents_can == 'send'" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                                <a href="#"
                                    class="px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                    :class="{ 'text-blue-500 font-bold': agents_can == 'request' }"
                                    @click.prevent="switchAgent('request')">
                                    <span class="flex flex-grow">Only request recordings</span>
                                    <vue-feather v-if="agents_can == 'request'" type="check"
                                        class="w-4 h-4 ml-2 self-center"></vue-feather>
                                </a>
                            </template>
                        </jet-dropdown>
                    </div>
                </div>



                <a href="#" @click.prevent="toggleAutotag"
                    :class="{ 'pointer-events-none': !$page.props.canManageSettings }"
                    class="flex flex-row mt-5 justify-between " v-if="trigger && !is_modal">
                    <div class="flex flex-row items-start flex-grow">
                        Analytics: add <code
                            class="text-xs bg-white px-2 py-1 rounded-full font-mono text-gray-500 mx-1">birdie</code>
                        tags to
                        conversations
                    </div>
                    <div class="flex items-center">
                        <toggle :checked="autotag" @click.prevent.stop @update="toggleAutotag"></toggle>
                    </div>
                </a>

                <a href="#" @click.prevent="toggleAutobot" class="flex flex-row mt-5 justify-between "
                    v-if="trigger && !is_modal && autobot.enabled"
                    :class="{ 'pointer-events-none': !$page.props.canManageSettings }">
                    <div class="flex flex-col items-start flex-grow">
                        <span class="">Ask for a recording when a user starts a conversation <docs-link
                                href="https://docs.birdie.so/birdie-docs/helpdesk/intercom/screen-recording/misc." /></span>
                        <span class="italic">only if you don’t use Intercom Workflows</span>
                    </div>
                    <div class="flex items-center">
                        <toggle :checked="autobot.enabled" @click.prevent.stop @update="toggleAutobot"></toggle>
                    </div>
                </a>




                <div class="flex flex-row mt-5 items-start " v-if="trigger && !is_modal"
                    :class="{ 'pointer-events-none': !$page.props.canManageSettings }">
                    <!--             <div class="flex items-center flex-grow">
                        <span class="text-black">Ask for a recording when a user starts a chat</span>
                    </div> -->
                    <div v-show="autobot.enabled" class="flex flex-grow">
                        <!--                 <list-toggle :checked="is_intercom_hash" class="flex-grow">
                            <template #title>
                            <span class="text-black">Ask for a recording when a user starts a chat</span>
                            </template>
                            <template #content> -->

                        <div class="py-5 flex grid flex-grow grid-cols-2 gap-5 justify-between">

                            <div class="flex flex-col">
                                <label class="label text-sm pl-2 mb-1 text-gray-600">Your Message (optional)</label>
                                <textarea
                                    class="rounded-xl p-5 bg-gray-100 border-transparent focus:border-transparent focus:ring-0"
                                    placeholder="Your message here…" v-model="autobot.message"
                                    @input="changedMessage"></textarea>

                                <label class="label mt-5 text-sm pl-2 mb-1 text-gray-600">Call to action
                                    (mandatory)</label>
                                <input type="text" :placeholder="default_link"
                                    class="rounded-xl p-5 bg-gray-100 border-transparent focus:border-transparent focus:ring-0"
                                    v-model="autobot.link" @input="changedLink" />

                                <label class="label mt-5 text-sm pl-2 mb-1 text-gray-600">Confirmation message
                                    (mandatory)</label>
                                <textarea
                                    class="rounded-xl p-5 bg-gray-100 border-transparent focus:border-transparent focus:ring-0"
                                    :placeholder="default_thanks" v-model="autobot.thanks"
                                    @input="changedThanks"></textarea>

                                <label
                                    class="label mt-5 pt-5 text-sm mx-2 mb-1 text-gray-900 border-t border-gray-200">Markup:
                                    enclose text with <span class="font-bold">**two stars**</span> for bold and <span
                                        class="italic">__two underscores__</span> for italic.</label>

                            </div>

                            <div class="flex flex-col">
                                <label class="label text-sm text-gray-600 pl-2 mb-1">Preview:</label>
                                <div class="flex flex-col rounded-b-xl p-5 shadow-2xl">
                                    <div class="flex flex-row justify-end">
                                        <div class="text-sm text-white bg-blue-500 rounded ml-10 px-5 py-4">
                                            Can you help me?
                                        </div>
                                    </div>
                                    <div class="flex flex-row justify-start mt-5">
                                        <div
                                            class="text-sm text-black bg-gray-200 rounded mr-10 px-5 py-4 overflow-hidden">
                                            <p class="mb-3 break-normal" v-show="autobot.message.length > 0"
                                                v-html="parse_markup(autobot.message)"></p>
                                            <p><a href="#" class="text-blue-500 underline break-normal"
                                                    @click.prevent.stop v-html="parse_markup(autobot.link)"></a></p>
                                        </div>
                                    </div>
                                    <div class="flex flex-row justify-end mt-5">
                                        <div class="text-sm text-white bg-blue-500 rounded ml-10 px-5 py-4">
                                            <img src="/img/screenshot_example.png" alt="video thumbail" class="w-40" />
                                        </div>
                                    </div>
                                    <div class="flex flex-row justify-start mt-5">
                                        <div
                                            class="text-sm text-black bg-gray-200 rounded mr-10 px-5 py-4 overflow-hidden">
                                            <p><a href="#" class="break-normal" @click.prevent.stop
                                                    v-html="parse_markup(autobot.thanks)"></a></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row justify-end mt-4">
                                    <div
                                        class="rounded-full w-14 h-14 bg-blue-500 flex justify-center items-center shadow-xl">
                                        <vue-feather type="chevron-down" class="h-8 w-8 text-white"></vue-feather>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!--                     </template>
                        </list-toggle> -->
                    </div>
                    <!--             <div class="flex items-center">
                        <toggle
                            :checked="autobot.enabled"
                            @click.prevent.stop
                            @update="toggleAutobot"></toggle>
                    </div> -->
                </div>

            </div>



            <jet-section-border v-if="trigger && !is_modal && (trigger.enabled == 1 || the_triggers_enabled > 0)" />


            <a href="#" @click.prevent="toggle" class="flex flex-row "
                v-if="trigger && !is_modal && the_triggers.length == 1 && trigger.enabled == 1"
                :class="{ 'pointer-events-none': !$page.props.canManageSettings }">
                <div class="flex items-center flex-grow">
                    <span class="">Birdie SDK & Birdie Link: Forward incoming recordings to Intercom<br />
                        <span class="text-xs text-gray-500">Most setups don't need this - use with care as it could
                            result in new tickets being created while you've already received the recordings another
                            way. </span></span>
                </div>
                <div class="flex items-center">
                    <toggle :checked="enabled" @click.prevent.stop @update="toggleIntercom"></toggle>
                </div>
            </a>


            <div class="flex flex-row"
                v-else-if="trigger && !is_modal && the_triggers.length > 1 && the_triggers_enabled > 0"
                :class="{ 'pointer-events-none': !$page.props.canManageSettings }">

                <div class="flex items-start flex-grow gap-x-2 ">
                    <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4 mt-1" /> -->
                    <span class="">Birdie SDK & Birdie Link: Forward incoming recordings to one of your Intercom
                        workspaces<br />
                        <span class="text-xs text-gray-500">Most setups don't need this - use with care as it could
                            result in new tickets being created while you've already received the recordings another
                            way. </span></span>

                </div>
                <div class="flex items-center flex-grow min-w-1/4 justify-end ">

                    <jet-dropdown align="left" width="36" class="flex self-center" ref="triggerDropdown">
                        <template #trigger>
                            <span class="inline-flex rounded-md">
                                <button type="button"
                                    class="inline-flex items-center px-2 py-2 border border-transparent leading-4 font-medium rounded-md bg-transparent hover:bg-white  focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition"
                                    :class="{ 'text-blue-500 hover:text-blue-700': trigger_forward != null, 'text-gray-300 hover:text-gray-500': trigger_forward == null }">

                                    <span v-if="trigger_forward != null" class="font-bold">
                                        {{ JSON.parse(trigger_forward.details).user.app.name }}
                                    </span>
                                    <span v-else class="font-bold">
                                        No forwarding
                                    </span>

                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clip-rule="evenodd" />

                                    </svg>
                                </button>
                            </span>
                        </template>

                        <template #content>
                            <inertia-link href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                :class="{ 'text-blue-500 font-bold': trigger_forward == null }"
                                @click.prevent.stop="updateTriggerDefault(null)">
                                <span class="flex flex-grow">No forwarding</span>
                                <vue-feather v-if="trigger_forward == null" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                            <inertia-link v-for="trig in triggers" :key="trig.id" href="#"
                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row cursor-pointer"
                                :class="{ 'text-blue-500 font-bold': trig.id == trigger_forward_id }"
                                @click.prevent.stop="updateTriggerDefault(trig)">
                                <span class="flex flex-grow">{{ JSON.parse(trig.details).user.app.name }}</span>
                                <vue-feather v-if="trig.id == trigger_forward_id" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </inertia-link>
                        </template>
                    </jet-dropdown>
                </div>
            </div>
            <jet-section-border />


            <div class="flex flex-col" v-if="trigger && !is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex flex-col justify-between items-start gap-x-2">
                        <span class="flex flex-shrink items-center gap-x-2">
                            <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                            Your Birdie link to paste in Fin
                            <docs-link href="https://docs.birdie.so/birdie-docs/helpdesk/intercom/flows/fin" />
                        </span>

                        <div class="flex justify-between text-sm">
                            <span
                                class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                v-clipboard:copy="fin_ai_agent" v-clipboard:success="copied">{{ fin_ai_agent
                                }}
                                <ClipboardIcon class="h-3 w-3 ml-1" v-tippy="{ content: 'copy in your clipboard' }" />
                            </span>
                            <div class="flex flex-grow"></div>
                        </div>
                    </div>
                </div>
            </div>




        </div>


    </div>

</template>

<script>
import Toggle from '@/Components/UI/Toggle'
import ButtonLink from '@/Jetstream/ButtonLink'
import JetDropdown from '@/Jetstream/Dropdown'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import Flows from '@/Components/Settings/Integrations/Flows'
import { ClipboardIcon } from "@heroicons/vue/16/solid"

export default {

    props: ['the_triggers', "is_modal", "flows", "docs", "name"],

    components: {
        Toggle, ButtonLink, JetDropdown, JetSectionBorder, Flows, ClipboardIcon
    },

    created: function () {

        if (this.triggers && this.the_triggers) {
            this.the_triggers.forEach(function (trig) {
                this.triggers.push(JSON.parse(JSON.stringify(trig)))
                if (trig.enabled) {
                    this.trigger_forward = JSON.parse(JSON.stringify(trig))
                    this.the_triggers_enabled++
                }
            }.bind(this))
            //console.log(JSON.parse(this.trigger_forward.details).user.app.name)
            this.switchTrigger(this.the_triggers[0])
            /*
            this.autobot.message = this.default_message
            this.autobot.link = this.default_link
            this.autobot.thanks = this.default_thanks
            if (this.trigger.metadata) {
                let metadata = JSON.parse(this.trigger.metadata)
                if (metadata.auto_reply) {
                    this.autobot.enabled = metadata.auto_reply.enabled
                    if (metadata.auto_reply.message == null) {
                        this.autobot.message = ""
                    } else if (metadata.auto_reply.message) {
                        this.autobot.message = metadata.auto_reply.message
                    }
                    if (metadata.auto_reply.link) {
                        this.autobot.link = metadata.auto_reply.link
                    }
                    if (metadata.auto_reply.thanks) {
                        this.autobot.thanks = metadata.auto_reply.thanks
                    }
                }
            }*/
        }
    },

    data() {
        return {
            trigger: null,
            triggers: [],
            trigger_forward: null,
            default_message: "Click below if you want to add a screen recording to speed-up resolution:",
            default_link: "Start screen recording",
            default_thanks: "Recording received 🙌",
            autobot: {
                message: "",
                link: "",
                thanks: "",
                enabled: false,
            },
            autotag: false,
            timeout: {},
            lastTypeMoment: 0,
            buffer: 900,
            saving: false,
            agents_can: 'all',
            default_agents_can: 'all',
            app_name: 'Birdie',
            is_enabled: this.the_triggers && this.the_triggers != false && this.the_triggers.length > 0,
            expandInfo: false,
            the_triggers_enabled: 0, // tell if any of the multiple triggers is enabled
            fin_ai_agent: `https://${this.$page.props.user.current_team.slugname}.birdie.so/urec/intercom?email=`,
        }
    },

    mounted: function () {
    },

    methods: {
        clickRow: function () {
            if (this.is_enabled) {
                return
            }
            this.expandInfo = !this.expandInfo
        },
        switchAgent: function (can) {
            this.agents_can = can
            this.updateTrigger()
        },
        switchTrigger: function (trig) {

            this.trigger = trig
            this.autobot.message = this.default_message
            this.autobot.link = this.default_link
            this.autobot.thanks = this.default_thanks
            this.autobot.enabled = false
            this.agents_can = this.default_agents_can
            this.autotag = false
            if (this.trigger.metadata) {
                let metadata = JSON.parse(this.trigger.metadata)
                if (metadata.auto_reply) {
                    this.autobot.enabled = metadata.auto_reply.enabled
                    if (metadata.auto_reply.message == null) {
                        this.autobot.message = ""
                    } else if (metadata.auto_reply.message) {
                        this.autobot.message = metadata.auto_reply.message
                    }
                    if (metadata.auto_reply.link) {
                        this.autobot.link = metadata.auto_reply.link
                    }
                    if (metadata.auto_reply.thanks) {
                        this.autobot.thanks = metadata.auto_reply.thanks
                    }
                }
                if (metadata.agents_can) {
                    this.agents_can = metadata.agents_can
                    //console.log(this.agents_can)
                }
                if (metadata.tag_conversations) {
                    this.autotag = metadata.tag_conversations
                }
            }
            if (this.$refs.autobotDropdown) {
                this.$refs.autobotDropdown.close()
            }
            if (this.$refs.agentscanDropdown) {
                this.$refs.agentscanDropdown.close()
            }
        },
        updateTriggerDefault: function (trig) {
            if (!this.$page.props.canManageSettings) {
                return
            }
            var trigger_id_to_disable = 0
            var trigger_id_to_enable = 0
            if (this.trigger_forward != null) {
                trigger_id_to_disable = this.trigger_forward.id
            }
            if (trig != null) {
                trigger_id_to_enable = trig.id
            }
            this.trigger_forward = trig
            if (trigger_id_to_disable == 0 && trigger_id_to_enable == 0) {
                return
            }
            let url = this.$page.props.api_url + '/v1/integration/' + this.trigger.id;
            var params = {
                //enabled: this.trigger.enabled,
                action: "intercom_switch_workspace_trigger",
                integration_to_enable: trigger_id_to_enable,
                integration_to_disable: trigger_id_to_disable
            };
            if (this.$refs.triggerDropdown) {
                this.$refs.triggerDropdown.close()
            }
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    // refresh the data
                    this.triggers = []
                    this.the_triggers.forEach(function (trig) {
                        if (trig.id == trigger_id_to_enable) {
                            trig.enabled = true
                        } else if (trig.id == trigger_id_to_disable) {
                            trig.disabled = true
                        }
                        this.triggers.push(JSON.parse(JSON.stringify(trig)))
                    }.bind(this))
                })
                .catch(e => {
                    console.error(e);
                });
        },
        parse_markup: function (message) {
            const bold = /\*{2}([A-Za-z0-9\W][A-Za-z0-9\W]+[A-Za-z0-9\W])\*{2}/gi
            const italics = /_{2}([A-Za-z0-9\W][A-Za-z0-9\s\W]+[A-Za-z0-9\W])_{2}/gi
            var text = message.replace(bold, '<b>$1</b>')
            text = text.replace(italics, '<i>$1</i>')
            return text
        },
        changedMessage: function () {
            this.autobot.message = this.autobot.message.replace(/<[^>]*>?/gm, '')
            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer || this.saving) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () { this.updateTrigger() }.bind(this), this.buffer);
            this.lastTypeMoment = now;
        },
        changedLink: function () {
            this.autobot.link = this.autobot.link.replace(/<[^>]*>?/gm, '')
            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer || this.saving) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () { this.updateTrigger() }.bind(this), this.buffer);
            this.lastTypeMoment = now;
        },
        changedThanks: function () {
            this.autobot.thanks = this.autobot.thanks.replace(/<[^>]*>?/gm, '')
            let now = new Date().getTime();
            if (now - this.lastTypeMoment < this.buffer || this.saving) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () { this.updateTrigger() }.bind(this), this.buffer);
            this.lastTypeMoment = now;
        },
        toggleAutobot: function (checked) {
            this.autobot.enabled = !this.autobot.enabled
            this.updateTrigger()
        },
        toggleAutotag: function (checked) {
            this.autotag = !this.autotag
            this.updateTrigger()
        },
        toggleIntercom: function (checked) {
            this.trigger.enabled = checked ? 1 : 0
            this.updateTrigger()
        },
        toggleTag: function (checked) {
            this.autotag = !this.autotag
            this.updateTrigger()
        },
        toggle: function () {
            if (this.trigger.enabled == 1) {
                this.trigger.enabled = 0;
            } else {
                this.trigger.enabled = 1;
            }
            this.updateTrigger();
        },
        updateTrigger: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            this.saving = true
            let url = this.$page.props.api_url + '/v1/integration/' + this.trigger.id;
            var _intercom_autobot = this.autobot
            if (this.autobot.link.trim().length == 0) {
                _intercom_autobot.link = this.default_link
            }
            if (this.autobot.thanks.trim().length == 0) {
                _intercom_autobot.thanks = this.default_thanks
            }

            var params = {
                enabled: this.trigger.enabled,
                agents_can: this.agents_can,
                intercom_autobot: _intercom_autobot,
                autotag: this.autotag
            }

            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    if (this.the_triggers.length > 1) {
                        // refresh the data
                        //this.trigger = response.data

                        var new_triggers = []
                        this.triggers.forEach(function (trig) {
                            if (trig.id == response.data.id) {
                                new_triggers.push(JSON.parse(JSON.stringify(response.data)))
                            } else {
                                new_triggers.push(JSON.parse(JSON.stringify(trig)))
                            }
                        }.bind(this))
                        this.triggers = new_triggers
                        this.switchTrigger(response.data)
                    } else {
                        this.autobot = _intercom_autobot
                    }
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        },
        toggleTag: function () {

        }
    },

    computed: {
        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        },
        enabledTag: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        },
        is_intercom_hash() {
            return window.location.hash == '#intercom'
        },
        trigger_forward_id() {
            return this.trigger_forward != null ? this.trigger_forward.id : 0
        }
    }
}

</script>

<style scoped></style>
